var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 14323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M2.833.576A1.5 1.5 0 10.71 2.696L6.015 8 .71 13.303a1.5 1.5 0 102.122 2.122l5.303-5.304 5.303 5.304a1.5 1.5 0 102.122-2.122L10.257 8l5.304-5.303A1.5 1.5 0 1013.439.576L8.136 5.879 2.833.576z",
    fill: "#D9D9D9"
  }))));
}
SvgCross.displayName = 'Cross';
export default SvgCross;